// @flow
export const FORM_FIELD_THEME_API = {
  root: '',
  disabled: '',
  error: '',
  label: '',
  inputWrapper: ''
};
